import Skeleton from "common/components/ui/Skeleton";
import type { CampaignOutreachType } from "common/types";

import { CAMPAIGN_OUTREACH_OPTIONS } from "../../../constants";
import useCampaignMetrics from "../../../datahooks/useCampaignMetrics";

export default function CampaignMetrics({
  id,
  outreachType,
}: {
  id: string;
  outreachType: CampaignOutreachType;
}) {
  const { campaignMetrics, isLoadingCampaignMetrics } = useCampaignMetrics(id);

  if (isLoadingCampaignMetrics)
    return <Skeleton className="mx-auto h-4 w-16" />;

  if (!campaignMetrics) return "-";

  const stringValue =
    CAMPAIGN_OUTREACH_OPTIONS[outreachType].getSuccessString(campaignMetrics);
  // biome-ignore lint/security/noGlobalEval: this usage is safe since the value comes from the server
  const numberValue = eval(stringValue);

  return (
    <span className="text-nowrap text-button-xs">
      ({stringValue}) {numberValue ? Math.round(numberValue * 100) : 0}%
    </span>
  );
}
